import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  cppoDimensionSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  dimensionBox: {
    paddingBottom: `${theme.spacing(3)} !important`,
  },
  dimensionWrapper: {
    paddingTop: theme.spacing(3),
    width: '100%',
  },
  rowWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  tableSubHeading: {
    marginTop: theme.spacing(3),
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.palette.labraText.description,
  },
}))
